import type { FaireProductEntity } from "../../entity_types/product";

export const p_ea35egy4z5: FaireProductEntity = {
  token: "p_ea35egy4z5",
  type: "product",
  name: "Frosted Star 18K Gold Plated Stainless Steel Ring - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/9f6cf769b30689d9b0d1322ba570ea722bc803229f450a3f49434bf9dc48685e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5d763f69fe406cd0480a80e5089b639def20988d98a278a8252b5a05faeb9ecc.jpeg",
    "https://cdn.faire.com/fastly/7daa89d725daf85530b9dc7794005a0d64360cb24ab048ed84c604923552f2ac.jpeg",
    "https://cdn.faire.com/fastly/4ca460286f036f0192e60ae9e86c793a958404f0729d6bb2b749723ca4ccd3e4.jpeg",
    "https://cdn.faire.com/fastly/269d0261c6bb5f671ffac0bfdf0225aa877a77fd8f12cd8cab6b5c7d89bbb4b8.jpeg",
    "https://cdn.faire.com/fastly/88a25c619d9269b5f5b926c34acc7f813b5744d5991da7056dd05563f19ca2bc.jpeg",
  ],
  priceDollars: 4.81,
  description:
    "Type: Ring\nMaterial : Stainless steel ,18K gold plated\nSize : Please refer to Size chart of rings\nProcess: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n★Made of high quality stainless steel,Lead-free,Harmless to Human Body.\n★Perfect jewelry gifts ",
  tags: [],
  msrpDollars: 12.01,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:21.674Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
